import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';

import { Router } from '@angular/router';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {ErrorMessageService} from '../services/errorMessage.service';

@Injectable({providedIn: 'root'})
export class TokeninterceptorService implements HttpInterceptor {

  constructor(
    private router: Router,
    private errorMessageService: ErrorMessageService) {
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const accessToken = localStorage.getItem('aWallOAuthAccessToken');
    let headers = request.headers;

    if (accessToken) {
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }

    if (headers.has('X-Skip-Interceptor')) {
      headers = headers.delete('X-Skip-Interceptor');
    }

    const cloned = request.clone({
      headers: headers
    });

    return next.handle(cloned).pipe(
      tap(
        () => {},
        (error) => {
          if (request.headers.has('X-Skip-Interceptor')) {
            return;
          }
          if (error.status === 401 || error.status === 403) {
            this.errorMessageService.setError(error.status);
            this.router.navigate(['/login']);
          }
        }
      )
    );
  }
}
